<template>
    <v-dialog
        v-model="display"
        width="350"
        @keyup.enter="close" @keyup.space="close"
        >
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>{{ content }}</v-card-text>
            <v-card-actions>
                <v-btn text @click="close" >
                    {{ $t("BTN_CANCEL") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "AlertDialog",
    data() {
        return {
            title: null,
            content: null,
            display: false
        }
    },
    methods: {
        close() {
            this.display = false;
            this.title = null;
            this.content = null;
        },
        open(title, content) {
            this.display = true;
            this.title = title;
            this.content = content;            
        }
    },
    mounted() {
        
    }
}
</script>